import { NAVIGATOR_CONFIG } from "../../headless/children";
function StackHeaderBackButton(_props) {
  return null;
}
Object.assign(StackHeaderBackButton, {
  [NAVIGATOR_CONFIG]: true
});
function appendStackHeaderBackButtonPropsToOptions(options, props) {
  return {
    ...options,
    headerBackTitle: props.children,
    headerBackTitleStyle: props.style,
    headerBackIcon: props.src ? {
      type: "image",
      source: props.src
    } : void 0,
    headerBackButtonDisplayMode: props.displayMode,
    headerBackButtonMenuEnabled: props.withMenu,
    headerBackVisible: props.hidden !== void 0 ? !props.hidden : void 0
  };
}
export {
  StackHeaderBackButton,
  appendStackHeaderBackButtonPropsToOptions
};
//# sourceMappingURL=StackHeaderBackButton.js.map
